import { useContext } from 'react';
import { RequestAccessType } from '../constants/requestAccessType';
import { AccessCheckAccessInfoContext } from '../contexts/AccessCheckAccessInfoContext';

// `missingSeats` is only populated by the RESOURCE-mode evaluation path; SCOPE
// always leaves it empty. It's also dormant today: AccessCheckProvider hardcodes
// `lowestSeatRequirement: ''` because the upstream evaluation RPC only returns
// a boolean decision. Once the provider pipes through real seat data, this hook
// will start returning SEAT correctly.
export function useRequestAccessType() {
  const accessInfo = useContext(AccessCheckAccessInfoContext);
  if (accessInfo.missingSeats.length > 0) {
    return RequestAccessType.SEAT;
  }
  return RequestAccessType.PERMISSION;
}